import { FaIcon } from '@ifixit/ui/components/icon';
import { cn } from '@ifixit/ui/lib/utils';

interface StepNavProps {
   // Destination names, already localized; null at either end of the guide.
   prevLabel: string | null;
   nextLabel: string | null;
   onPrev: () => void;
   onNext: () => void;
   className?: string;
}

/**
 * The pager at the foot of every screen: the neighbouring screens by name, so
 * advancing doesn't mean travelling back to the header arrows on every step.
 */
export function StepNav({ prevLabel, nextLabel, onPrev, onNext, className }: StepNavProps) {
   if (!prevLabel && !nextLabel) {
      return null;
   }

   // A plain container, not a <nav>: the rail is already the "Guide steps"
   // landmark, and a second one under the same name is noise to skip past.
   // Grid cells rather than percentage widths, which overran a 400px embed.
   return (
      <div
         className={cn(
            'col-span-full mt-8 grid grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] items-center gap-3 border-t border-gray-300 pt-4',
            className
         )}
      >
         {prevLabel && (
            <button
               type="button"
               onClick={onPrev}
               className="button-ghost button-md col-start-1 min-w-0 max-w-full justify-self-start text-gray-700"
            >
               <FaIcon name="arrow-left" aria-hidden />
               <span className="truncate">{prevLabel}</span>
            </button>
         )}
         {nextLabel && (
            <button
               type="button"
               onClick={onNext}
               className="button-primary button-md col-start-2 min-w-0 max-w-full justify-self-end"
            >
               <span className="truncate">{nextLabel}</span>
               <FaIcon name="arrow-right" aria-hidden />
            </button>
         )}
      </div>
   );
}
